import {BASE_SERVICE_URL} from '../lib/constants'

export default function upload(file) {
    var data = new FormData();
    data.append('file', file);

    return fetch(BASE_SERVICE_URL + "/upload", {
        credentials: 'same-origin',
        method: 'POST',
        body: data
    }).then((response) => {
        if (response.ok) {
            return response.json();
        } else {
            var error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
    });
}
